import type { ErrorInfo } from 'react';
import React from 'react';

import { Amplify } from '@aws-amplify/core';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';

import ServiceWorkerUpdateDialog from './ServiceWorkerUpdateDialog';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import ErrorFallback from '@/components/ErrorFallback';
import { aws, version } from '@/constants/env';
import BlockingLoading from '@/containers/BlockingLoading';
import ChangelogOnUpdate from '@/containers/ChangelogOnUpdate';
import Header from '@/containers/Header';
import Loading from '@/containers/Loading';
import Main from '@/containers/Main';
import Snackbar from '@/containers/Snackbar';
import { api, service } from '@/share';
import { store } from '@/store';

import './index.css';

// eslint-disable-next-line import/order
import { isFake } from './shareRunFake';

// Fakeを起動
if (isFake) {
  // eslint-disable-next-line no-console
  console.warn('※ Fake環境で実行');
}

// 古いブラウザのwithResolvers対策
if (!(window.Promise as any).withResolvers) {
  (window.Promise as any).withResolvers = () => {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { resolve, reject, promise };
  };
}

Amplify.configure(aws);

ReactDOM.render(
  <div>
    <Provider store={store}>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={(error: Error, errorInfo: ErrorInfo) => {
          api.logger.error(`${error.stack || ''}\n${errorInfo.componentStack}`);
          const deviceInfo = service.device.getDeviceInfo();
          const logText = api.logger.outputLog();
          api.wagakoAppApi.errorReport({
            title: `v${version}:Compornent Error: ${error.message}`,
            content: `[Error]\n${error.stack}\n[Log]\n${logText}\n[Device]\n${JSON.stringify(deviceInfo)}`,
          })
            // eslint-disable-next-line no-console
            .then(() => console.log('Error Report'))
            // eslint-disable-next-line no-console
            .catch((e) => console.error(e));
        }}
      >
        <React.StrictMode>
          <Header />
          <Main />
          <ChangelogOnUpdate />
          <BlockingLoading />
          <Loading />
          <Snackbar />
        </React.StrictMode>
      </ErrorBoundary>
    </Provider>
    <div id="sw-update-dialog" />
  </div>,
  document.getElementById('root'),
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      try {
        // 更新中はチェンジログ表示を抑制し、controllerchange 時のみリロード
        sessionStorage.setItem('swUpdatePending', '1');
        // リロード後にチェンジログを表示するフラグ（バージョン値は新バンドル側で解決）
        sessionStorage.setItem('showChangelogAfterReload', '1');
      } catch {
        // sessionStorage 未対応環境では何もしない
      }
      ReactDOM.render(
        <ServiceWorkerUpdateDialog registration={registration} />,
        document.getElementById('sw-update-dialog'),
      );
    }
  },
});
